// use to perform various tasks on the data for the SilverStripe API
const dataHelper = {};

// checks that querstring parameters are numbers that are comma separated, e.g.: 1,2,3
dataHelper.isValidQuerystring = qs => {
  return (/^([1-9][0-9]{0,2}|1000)(,\s*([1-9][0-9]{0,2}|1000))*$/.test(qs));
};

// checks that querstring parameters is a number.
dataHelper.isValidNumber = num => {
  return (/^[1-9][0-9]{0,2}$/.test(num));
};

// return value from querystring URL list
dataHelper.getValueById = (qsUrlParams, qsUrlKey) => {
  const qsObj = Object.fromEntries(new URLSearchParams(qsUrlParams));
  let value = "";
  Object.keys(qsObj).forEach(function (key) {
    if (key === qsUrlKey) {
      value = qsObj[key];
    }
  });
  return value;
};

// checks if a valid querystring key from predefined list
dataHelper.isValidQsKey = (qsUrlKey) => {
  const arrValidQskeys = [
    "Page",  
    "ContractRegion", 
    "ContractSubRegion", 
    "Gender", 
    "Competency", 
    "Expertise", 
    "Language"
  ];
  let isValid = false;
  arrValidQskeys.forEach((item) => {
    if (qsUrlKey === item) {
      isValid = true;
    }
  });
  return isValid;
};

export default dataHelper;